import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'camelCaseToText',
    standalone: false
})
export class CamelCaseToTextPipe implements PipeTransform {
  constructor(
  ) {
  }
  
  transform(camelCaseString: string): string {
    return camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
      .replace(/^./, (str) => str.toUpperCase());
  }
}
